import React, { FC } from 'react';
import { PageLink, PageTitle } from '../../../../rbts/layout/core';
import { View } from './components/View';

const HistorialRecargasPage: FC = () => {
  const breadcrumbs: Array<PageLink> = [];

  return (
    <>
      <PageTitle breadcrumbs={breadcrumbs}>Historial de Recargas</PageTitle>
      <View />
    </>
  );
};

export { HistorialRecargasPage };
